/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP8_ANSWERS = [
    'Everyone is looking for the puppy.',
    'First, Holly has an idea and says, “Maybe he went to the kitchen!”',
    'There is food all over the kitchen! Stephanie wonders who will clean the mess.',
    'Next, Harry has an idea. He says, “Maybe the puppy went upstairs!”',
    'Holly’s room is a mess, too! Matt wonders how big the puppy is.',
    'Then, Tony has an idea. He says, “What if he went into my room?”',
    'Tony’s room is a mess, too! Tony wants to give the puppy back to the owners now.',
    'Finally, Stephanie finds the puppy! He is in the bathroom.',
    'The next morning, Holly and Harry see that the puppy is gone again! And it ate all the puppy food.',
    'Tony is carrying the puppy in a bag. He really wants to find the owners.',
];

// export const HHT2_EP8_ANSWER_SOUNDS = [
//     '/HHT2_AB EP08_dyr01.mp3',
//     '/HHT2_AB EP08_dyr02.mp3',
//     '/HHT2_AB EP08_dyr03.mp3',
//     '/HHT2_AB EP08_dyr04.mp3',
//     '/HHT2_AB EP08_dyr05.mp3',
//     '/HHT2_AB EP08_dyr06.mp3',
//     '/HHT2_AB EP08_dyr07.mp3',
//     '/HHT2_AB EP08_dyr08.mp3',
//     '/HHT2_AB EP08_dyr09.mp3',
//     '/HHT2_AB EP08_dyr10.mp3',
// ];

export const HHT2_EP8_ANSWER_SOUNDS = [
    '/4f4becfb2f2c02da5bff4420d3525333.mp3',
    '/e34d62e97884e58b2af1e19fff7d5591.mp3',
    '/6adedaa9cdecdd29899dfd53c71a4fe4.mp3',
    '/924abd7a312bbb70f1fb448629bf8f2b.mp3',
    '/e3086c7781584699331eda062555cb0d.mp3',
    '/a093ce8eb4d511ef9620b8938cf2bff1.mp3',
    '/d82b61b6592bd585b5d1d10124a2db94.mp3',
    '/f60ca823e63a1dcb117492c212293037.mp3',
    '/6656646281ead7667c743485a5f5d790.mp3',
    '/39a51e65e0ad10bfa30e355e487e4d0b.mp3',
];


export const HHT2_EP8_QUIZ_ITEMS = [{
    'A': HHT2_EP8_ANSWERS[1],
    'B': HHT2_EP8_ANSWERS[8],
    'SoundIndexA': 1,
    'SoundIndexB': 8,
    'answer': HHT2_EP8_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP8_ANSWERS[4],
        'B': HHT2_EP8_ANSWERS[2],
        'SoundIndexA': 4,
        'SoundIndexB': 2,
        'answer': HHT2_EP8_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP8_ANSWERS[5],
        'B': HHT2_EP8_ANSWERS[7],
        'SoundIndexA': 5,
        'SoundIndexB': 7,
        'answer': HHT2_EP8_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP8_ANSWERS[0],
        'B': HHT2_EP8_ANSWERS[9],
        'SoundIndexA': 0,
        'SoundIndexB': 9,
        'answer': HHT2_EP8_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
